import createModuleStorage from "app/pages/sales-intelligence/services/storage/factory";

export const managementIntegrationHsStorageProvider = createModuleStorage(
    localStorage,
    "si:management-integration-hubspot",
);

export const managementIntegrationSfStorageProvider = createModuleStorage(
    localStorage,
    "si:management-integration-salesforce",
);

export const managementIntegrationDynamicsStorageProvider = createModuleStorage(
    localStorage,
    "si:management-integration-dynamics",
);

export const managementIntegrationSignalApiStorageProvider = createModuleStorage(
    localStorage,
    "si:management-integration-signal-api",
);
